import React from "react";
import { usePriceSummary } from "../../../Pregrine/CartPage/PriceSummary/usePriceSummary";
import classes from "./priceSummary.module.css";
import TaxSummary from "./taxSummary";
import ShippingSummary from "./shippingSummary";
import DiscountSummary from "./discountSummary";
import { FaRupeeSign } from "react-icons/fa";
import CouponCode from "../PriceAdjustments/CouponCode";
import { formatIndianNumber } from "../../../utility/formatPrice";

const PriceSummary = (props) => {
  const {
    isUpdating,
    setIsCartUpdating,
    hasOutOfStockItem,
    checkoutStep,
    CHECKOUT_STEP,
  } = props;
  const talonProps = usePriceSummary();

  const {
    handleProceedToCheckout,
    hasError,
    hasItems,
    isCheckout,
    isLoading,
    flatData,
    couponCodeText,
    setCouponCodeText,
    data,
  } = talonProps;

  if (hasError) {
    return (
      <div className={classes.root}>
        <span className={classes.errorText}>
          <span>Something went wrong. Please refresh and try again.</span>
        </span>
      </div>
    );
  } else if (!hasItems) {
    return null;
  }

  const excludedSkus = [
    "9316653.7SS",
    "9281432.6SS",
    "9194321.5SS",
    "9243992.4SS",
    "9210445.3SS",
    "9382865.2SS",
    "9382872.1SS",
    "5IS66860.1KASS",
    "5IS69860.2KASS",
    "5B36N0250GB.6KASS",
    "5MG16199GB.4KASS",
    "5MA27500IN.5KASS",
    "5GH85BB390.3KASS",
    "5VF421.7KASS",
  ];

  const hasExcludedProduct = data?.cart.items?.some((item) =>
    excludedSkus.includes(item.product?.sku)
  );

  const { subtotal, total, discounts, giftCards, taxes, shipping } = flatData;

  const isPriceUpdating = isUpdating || isLoading;
  const priceClass = isPriceUpdating ? classes.priceUpdating : classes.price;
  const totalPriceClass = isPriceUpdating
    ? classes.priceUpdating
    : classes.totalPrice;

  const proceedToCheckoutButton = !isCheckout ? (
    <>
      <div className="row mt-2 m-auto justify-content-center">
        <button
          disabled={isPriceUpdating || hasOutOfStockItem}
          priority={"high"}
          onClick={handleProceedToCheckout}
          className={classes.cartbutton}
        >
          Proceed to Checkout
        </button>
      </div>
    </>
  ) : null;

  return (
    <>
      <div className={classes.lineItems}>
        <span className={classes.lineItemLabel}>
          <h6>
            <span>Price ((Incl. of all taxes))</span>
          </h6>
        </span>
        <span className={priceClass}>
          <span className={classes.priceValue}>
            <FaRupeeSign />
            {formatIndianNumber(subtotal.value)}
          </span>
        </span>

        <DiscountSummary data={discounts} couponCodeText={couponCodeText} />

        <TaxSummary data={taxes} isCheckout={true} />

        {checkoutStep >= CHECKOUT_STEP?.METHOD ? (
          <ShippingSummary data={shipping} />
        ) : null}
      </div>
      {hasExcludedProduct ? null : (
        <small>
          INR249 shipping charges applicable on orders below INR2000
        </small>
      )}

      <hr />
      <CouponCode
        setIsCartUpdating={setIsCartUpdating}
        setCouponCodeText={setCouponCodeText}
      />
      <div className={classes.lineItems}>
        <span className={classes.totalLabel}>
          <h4>
            <b>Total</b>
          </h4>
        </span>
        <span className={totalPriceClass}>
          <h4>
            <b>
              <span className={classes.totalPrice}>
                <FaRupeeSign />
                {formatIndianNumber(
                  checkoutStep >= CHECKOUT_STEP?.METHOD
                    ? total.value
                    : shipping.length
                    ? total.value -
                      (shipping[0]?.selected_shipping_method
                        ? shipping[0]?.selected_shipping_method.amount?.value
                        : 0)
                    : total.value
                )}
              </span>
            </b>
          </h4>
        </span>
      </div>
      {proceedToCheckoutButton}
    </>
  );
};

export default PriceSummary;
